document.documentElement.classList.remove('no-js');

// Add products without navigating away; the customer chooses when to open the bag or checkout.
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form || !window.fetch || !window.FormData) return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  const originalText = button?.textContent;
  if (button) { button.disabled = true; button.textContent = 'Adding…'; }
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Could not add item');
    const added = await response.json();
    const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } }).then((res) => res.json());
    document.querySelectorAll('.bag-link span').forEach((label) => { label.textContent = `Bag (${cart.item_count})`; });
    if (button) button.textContent = 'Added to bag';
    form.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { item: added, cart } }));
  } catch (error) {
    form.submit();
  } finally {
    window.setTimeout(() => {
      if (button) { button.disabled = false; button.textContent = originalText || 'Add to bag'; }
    }, 1800);
  }
});

const loader = document.querySelector('[data-loader]');
if (loader) {
  if (document.documentElement.classList.contains('aw-intro-seen')) {
    loader.remove();
  } else {
    try { sessionStorage.setItem('awIntroSeen', 'true'); } catch (error) {}
    document.documentElement.classList.add('loader-active');
    const duration = Number(loader.dataset.duration) || 1400;
    const dismiss = () => {
      loader.classList.add('is-leaving');
      document.documentElement.classList.remove('loader-active');
      window.setTimeout(() => loader.remove(), 700);
    };
    window.addEventListener('load', () => window.setTimeout(dismiss, duration), { once: true });
    window.setTimeout(dismiss, duration + 3500);
  }
}

document.addEventListener('change', (event) => {
  const select = event.target.closest('.product-details select[name="id"]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const button = select.closest('form').querySelector('[type="submit"]');
  if (button) button.disabled = option.disabled;
});


document.querySelectorAll('[data-product-root]').forEach((root) => {
  const slides = [...root.querySelectorAll('[data-slide]')];
  const thumbs = [...root.querySelectorAll('[data-carousel-thumb]')];
  const current = root.querySelector('[data-carousel-current]');
  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

  const showSlide = (index) => {
    if (!slides.length) return;
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const active = i === activeIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === activeIndex));
    if (current) current.textContent = String(activeIndex + 1);
  };

  root.querySelector('[data-carousel-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
  root.querySelector('[data-carousel-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.carouselThumb))));

  const variantsNode = root.querySelector('[data-product-variants]');
  if (!variantsNode) return;
  let variants = [];
  try { variants = JSON.parse(variantsNode.textContent); } catch (error) { return; }

  const groups = [...root.querySelectorAll('[data-option-index]')];
  const idInput = root.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-product-price]');
  const addButton = root.querySelector('[data-add-button]');
  const addLabel = root.querySelector('[data-add-label]');

  const updateVariant = () => {
    const selected = groups.map((group) => group.querySelector('.variant-choice.is-selected')?.dataset.optionValue);
    const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
    if (!variant) {
      if (addButton) addButton.disabled = true;
      if (addLabel) addLabel.textContent = 'Unavailable';
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (price) price.textContent = variant.price;
    if (addButton) addButton.disabled = !variant.available;
    if (addLabel) addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
    if (variant.mediaId) {
      const mediaIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(variant.mediaId));
      if (mediaIndex >= 0) showSlide(mediaIndex);
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  groups.forEach((group) => {
    group.querySelectorAll('.variant-choice').forEach((choice) => {
      choice.addEventListener('click', () => {
        group.querySelectorAll('.variant-choice').forEach((button) => {
          const selected = button === choice;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        const label = group.querySelector('[data-option-label]');
        if (label) label.textContent = choice.dataset.optionValue;
        updateVariant();
      });
    });
  });
});
